import { cosApi } from 'services/cos-service/api';
import { MerchantPaymentConfig } from 'services/cos-service/models';

export const fetchMerchantPaymentConfig = async (merchantId: Uuid) => {
  return cosApi.get<MerchantPaymentConfig>(`/v3/merchants/${merchantId}/ecomm_payment_configs`);
};
